import { HowToStepperProps } from "@bluebottlecoffee/design-system/components";
import { toImageProps } from "./image";
import { HowToStepper } from "../sanity-schema";

type howToStepperPropsType = HowToStepper & { lang: string };

export const howToStepperProps = ({
  bgColor,
  title,
  stepper,
  lang,
}: howToStepperPropsType): HowToStepperProps => ({
  bgColor,
  title: title[lang],
  stepper: stepper.map(({ step, toggleName }) => ({
    steps: step.map(({ text, image }) => ({
      text: text[lang],
      image: toImageProps(image, lang),
    })),
    toggleName: toggleName[lang],
  })),
});
